import React, { FC, Fragment, KeyboardEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldArray, FieldArrayRenderProps, useFormikContext } from 'formik';
import { Box, IconButton, InputAdornment, TextField, Unstable_Grid2 as Grid } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';

import { AdminUpdateClientInput } from 'api';
import { ValidatedTextFieldNext } from 'components';

const ContentDomains: FC = () => {
  const [domain, setDomain] = useState('');
  const { values } = useFormikContext<AdminUpdateClientInput>();
  const { t } = useTranslation();

  function handleKeyDown(
    event: KeyboardEvent<HTMLDivElement>,
    arrayHelpers: FieldArrayRenderProps
  ) {
    if (event.key !== 'Enter') {
      return;
    }

    if (!domain.length) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    arrayHelpers.unshift(domain);
    setDomain('');
  }

  function renderDomain(arrayHelpers: FieldArrayRenderProps, index: number) {
    return (
      <Grid key={index} container alignItems="center">
        <Grid xs>
          <ValidatedTextFieldNext enableTrim disabled fullWidth name={`content_domains.${index}`} />
        </Grid>
        <Grid>
          <IconButton onClick={() => arrayHelpers.remove(index)} size="large">
            <CancelIcon color="disabled" />
          </IconButton>
        </Grid>
      </Grid>
    );
  }

  return (
    <FieldArray name="content_domains">
      {arrayHelpers => (
        <Fragment>
          <Box marginBottom={3}>
            <TextField
              value={domain}
              onChange={event => setDomain(event.target.value.trim())}
              fullWidth
              variant="outlined"
              color="primary"
              placeholder={t('admin:workspaceContentDomain')}
              onKeyDown={event => handleKeyDown(event, arrayHelpers)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <AddCircleIcon color="primary" />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Grid container direction="column" spacing={3}>
            {values.content_domains.map((datum: string, index: number) => (
              <Grid xs key={index}>
                {renderDomain(arrayHelpers, index)}
              </Grid>
            ))}
          </Grid>
        </Fragment>
      )}
    </FieldArray>
  );
};

export default ContentDomains;
